import React, { useEffect, useReducer, useRef, useState } from "react";
import MainContainer from "../../components/main-container/main-container.component";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import clientConfig from "../../env";
import { toast } from "react-toastify";
import { GoThumbsdown, GoThumbsup, GoTrash } from "react-icons/go";

import "./events.scss";

const initialArg = {
  eventName: "",
  eventDate: "",
  eventTime: "",
  shortDescription: "",
};

function reducer(state, action) {
  switch (action.type) {
    case "eventName": {
      return {
        ...state,
        eventName: action.payload,
      };
    }
    case "eventDate": {
      return {
        ...state,
        eventDate: action.payload,
      };
    }
    case "eventTime": {
      return {
        ...state,
        eventTime: action.payload,
      };
    }
    case "shortDescription": {
      return {
        ...state,
        shortDescription: action.payload,
      };
    }
    case "reset": {
      return initialArg;
    }
    default:
      return state;
  }
}

function EventsPage() {

  const dispatchAction = useDispatch();

  const confirmationModalRef = useRef();
  const token = useSelector((state) => state.user.token);
  const isAllTableDisable = useSelector(
    (state) => state.events.allTableDisable
  );

  const isMasterTable = useSelector(
    (state) => state.events.allTableDisable
  );

  const [formData, dispatch] = useReducer(reducer, initialArg);
  const [submittedTopics, setSubmittedTopics] = useState([]);
  const [paginatedTopics, setPaginatedTopics] = useState([]);
  const [totalPages, setTotalPages] = useState(null)

  const [disableTables, setDisableTables] = useState(isAllTableDisable || false);
  const [enableMasterTable, setEnableMasterTable] =
    useState(isMasterTable || false);

  const [topicId, setTopicId] = useState("");

  const [currentPage, setCurrentPage] = useState(null);
  const pageSize = 10;

  // change page
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    // slice data for current page
    const paginatedData = submittedTopics.slice(
      (currentPage - 1) * pageSize,
      currentPage * pageSize
    );
    setPaginatedTopics(paginatedData);
  }, [currentPage, submittedTopics]);

  useEffect(() => {
    getSubmittedEvents();
    getEventSettings();
  }, []);

  const getSubmittedEvents = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/getAllSubmittedEvents`,
        { headers: headers }
      );
      console.log(response?.data);

      // total pages
      const totalPages = Math.ceil(response?.data.length / pageSize);
      setTotalPages(totalPages);
      setSubmittedTopics(response?.data);
      setCurrentPage(1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApproveEvent = async (event, eventData) => {
    event.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/approve-event`,
        eventData,
        { headers: headers }
      );
      setSubmittedTopics(response?.data?.topics);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeclineEvent = async (event, eventData) => {
    event.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/decline-event`,
        eventData,
        { headers: headers }
      );
      setSubmittedTopics(response?.data?.topics);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteEvent = (event, topicId) => {
    event.preventDefault();
    setTopicId(topicId);
  }

  const handleConfirmDeleteEvent = async (event) => {
    event.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/delete-event`,
        {
          topic_id: topicId,
        },
        { headers: headers }
      );
      setSubmittedTopics(response?.data?.topics);
      if(response.status === 200) {
        setTopicId("");
        confirmationModalRef.current.click();
      }
      // total pages
      const totalPages = Math.ceil(response?.data?.topics.length / pageSize);
      setTotalPages(totalPages);
    } catch (error) {
      console.error(error);
    }
  };


  function handleInputChange(e, type) {
    dispatch({
      type: type,
      payload: e.target.value,
    });
  }

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };

      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/add-event`,
        formData,
        {
          headers: headers,
        }
      );

      console.log(response);

      if (response.status === 200) {
        if (response.data.type === "success") {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        dispatch({ type: "reset" });
      }
    } catch (error) {
      console.error(error);
    }
  };

  async function getEventSettings() {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/settings`,
        { headers: headers }
      );
      console.log(response?.data?.settings);

      dispatchAction({
        type: "EVENT_SETTINGS",
        payload: {
          allTableDisable: response?.data?.settings.disable_all_tables,
          masterTableEnable: response?.data?.settings.is_master_table_enable,
        },
      });
      setDisableTables(response?.data?.settings.disable_all_tables);
      setEnableMasterTable(response?.data?.settings.is_master_table_enable);

    } catch (error) {
      console.log(error);
    }
  }

  async function updateEventSetting(settingData) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      await axios.post(
        `${clientConfig.siteUrl}wl/v1/settings`,
        settingData,
        { headers: headers }
      );
    } catch(error) {
      console.log(error);
    }
  }

  const handleChangeSwitchbutton = (event) => {
    if (event.target.name === "disableTables") {
      setDisableTables(event.target.checked);
      updateEventSetting({
        disable_all_tables: event.target.checked,
        is_master_table_enable: enableMasterTable,
      });
      dispatchAction({
        type: "DISABLE_TABLES",
        payload: event.target.checked,
      });
    } else {
      setEnableMasterTable(event.target.checked);
      updateEventSetting({
        disable_all_tables: disableTables,
        is_master_table_enable: event.target.checked,
      });
      dispatchAction({
        type: "ADD_MASTER_TABLE",
        payload: event.target.checked,
      });
    }
  }

  const disabledButton = (approved) => {
    return parseInt(approved) === 1 || parseInt(approved) === 0 ? true : false;
  };

  const ActionButtons = ({ topic }) => {
    const ApproveButton = (
      <button
        className={`btn btn-secondary btn-sm action-btn-approve btn-block mt-0 mr-2 d-flex align-items-center justify-content-center rounded ${
          disabledButton(topic?.approved) ? "disabled" : ""
        }`}
        disabled={disabledButton(topic?.approved)}
        onClick={(event) =>
          handleApproveEvent(event, {
            topic_id: topic.id,
            topic_name: topic.topic_name,
            user_id: topic.user_id,
          })
        }
      >
        <GoThumbsup className="mr-1" />
        Approve
      </button>
    );

    const DeclineButton = (
      <button
        className={`btn btn-secondary btn-sm action-btn-decline btn-block m-0 d-flex align-items-center justify-content-center rounded ${
          disabledButton(topic?.approved) ? "disabled" : ""
        }`}
        disabled={disabledButton(topic?.approved)}
        onClick={(event) => handleDeclineEvent(event, { topic_id: topic.id })}
      >
        <GoThumbsdown className="mr-1" />
        {parseInt(topic?.approved) === 0 ? "Declined" : "Decline"}
      </button>
    );

    switch (topic.approved) {
      case "1":
        return (
          <small className="m-0 text-center  text-success w-100">
            Topic Approved
          </small>
        );
      case "0":
        return (
          <small className="m-0 text-center text-danger w-100">
            Topic Declined
          </small>
        );
      default:
        return (
          <>
            {ApproveButton}
            {DeclineButton}
          </>
        );
    }
  };

  // Render page numbers with ellipsis
  const renderPageNumbers = () => {
    let pages = [];

    if (totalPages <= 5) {
      pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    } else {
      if (currentPage <= 3) {
        pages = [1, 2, 3, 4, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        pages = [
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        ];
      } else {
        pages = [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    }

    return pages.map((page, idx) =>
      page === "..." ? (
        <li key={`ellipsis-${idx}`} className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      ) : (
        <li
          key={page}
          className={`page-item ${page === currentPage ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(page)}>
            {page}
          </button>
        </li>
      )
    );
  };

  return (
    <MainContainer>
      <div className="connections-container py-3 py-md-4 px-0 px-md-3">
        <div className="row">
          <div className="col-12 col-lg-4">
            <h1 className="title mb-4">Add Event</h1>
            <form id="supportForm" onSubmit={handleFormSubmit}>
              <div className="form-row mb-3">
                <div className="col">
                  <label htmlFor="firstname">
                    Change Current Event Name <span>*</span>
                  </label>
                  <input
                    required={true}
                    type="text"
                    id="eventName"
                    className="form-control"
                    placeholder="Event name"
                    value={formData.eventName}
                    onChange={(e) => handleInputChange(e, "eventName")}
                  />
                </div>
              </div>

              {/* <div className="form-group my-3">
                <label htmlFor="email">
                  Event Date <span>*</span>
                </label>
                <input
                //   required={true}
                  type="date"
                  className="form-control"
                  id="eventDate"
                  value={formData.eventDate}
                  onChange={(e) => handleInputChange(e, "eventDate")}
                />
              </div>

              <div className="form-group my-3">
                <label htmlFor="phone">
                  Time <span>*</span>{" "}
                </label>
                <input
                //   required={true}
                  type="time"
                  className="form-control"
                  id="phone"
                  placeholder="Enter your Phone number"
                  value={formData.eventTime}
                  onChange={(e) => handleInputChange(e, "eventTime")}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">
                  Event Shortdescription <span>*</span>
                </label>
                <textarea
                //   required={true}
                  className="form-control"
                  id="shortDescription"
                  rows="5"
                  placeholder="Enter Short Description"
                  value={formData.shortDescription}
                  onChange={(e) => handleInputChange(e, "shortDescription")}
                ></textarea>
              </div> */}

              <button type="submit" className="btn btn-primary rounded-10 px-5">
                Submit
              </button>
            </form>

            <hr className="w-100 my-4" />

            <h3 className="title mb-3">Table Settings</h3>

            {/* Disabled all Tables */}
            <div className="custom-control custom-switch">
              <input
                name="disableTables"
                type="checkbox"
                className="custom-control-input"
                id="disabletables"
                onChange={handleChangeSwitchbutton}
                checked={disableTables}
              />
              <label className="custom-control-label" for="disabletables">
                Disable all tables.
              </label>
            </div>

            {/* Add Master table */}
            <div className="custom-control custom-switch mt-2">
              <input
                name="masterTable"
                type="checkbox"
                className="custom-control-input"
                id="mastertable"
                onChange={handleChangeSwitchbutton}
                checked={enableMasterTable}
              />
              <label className="custom-control-label" for="mastertable">
                Add master table
              </label>
            </div>

            <hr className="w-100 my-4" />
          </div>

          <div className="col-12 col-lg-8">
            <h2 className="title mb-4">Submitted Topic List</h2>

            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Topic Name</th>
                  <th width="250">Action</th>
                  <th width="22px"></th>
                </tr>
              </thead>

              {paginatedTopics.length ? (
                paginatedTopics?.map((topic) => (
                  <tr key={topic.id} className="submitted-topic-row">
                    <td className="py-1" style={{ verticalAlign: "middle" }}>
                      {topic.topic_name}
                    </td>
                    <td className="d-flex justify-content-between py-1">
                      <ActionButtons topic={topic} />
                    </td>
                    <td className="py-1 text-center">
                      <button
                        className="btn p-0"
                        onClick={(e) => handleDeleteEvent(e, topic.id)}
                        data-toggle="modal"
                        data-target="#deleteConfirmation"
                      >
                        <GoTrash />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} align="center">
                    No record found.
                  </td>
                </tr>
              )}

              {submittedTopics.length > pageSize && (
                <tfoot>
                  <tr>
                    <td colSpan={3} align="center">
                      <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-center m-0">
                          {/* Previous button */}
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage - 1)}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page numbers */}
                          {renderPageNumbers()}

                          {/* Next button */}
                          <li
                            className={`page-item ${
                              currentPage === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(currentPage + 1)}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>
      <div className={`modal fade`} id="deleteConfirmation" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Delete Confirmation</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                ref={confirmationModalRef}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body text-left">
              <p>Are you sure you would like to delete permenantly?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary rounded-10"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary rounded-10"
                onClick={handleConfirmDeleteEvent}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </MainContainer>
  );
}

export default EventsPage;
